import React from 'react';
import PropTypes from 'prop-types';

const CardIcon = ({ className, size = 'md' }) => {
  const sizes = {
    sm: { width: '14.67', height: '10.67' },
    md: { width: '24', height: '18' },
  };

  return (
    <svg
      width={sizes[size].width}
      height={sizes[size].height}
      viewBox='0 0 24 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        className={className}
        d='M1 7H23M3 1H21C22.1046 1 23 1.89543 23 3V15C23 16.1046 22.1046 17 21 17H3C1.89543 17 1 16.1046 1 15V3C1 1.89543 1.89543 1 3 1Z'
        stroke='#242546'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

CardIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
};

export default CardIcon;
